import React from 'react';
import { Container, Box, Link, Typography } from '@mui/material';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <Container sx={{ py: 4, textAlign: 'center' }}>
      <Box>
        <Link href="/privacy-policy" color="text.secondary" variant="body2">
          Privacy Policy
        </Link>
        <Typography component="span" sx={{ mx: 0.5, opacity: 0.5 }}>
          •
        </Typography>
        <Link href="/terms-of-service" color="text.secondary" variant="body2">
          Terms of Service
        </Link>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {'Copyright © Medskool.org '} {year}
      </Typography>
    </Container>
  );
}
